import { Component, Prop, h } from '@stencil/core';

import { ImageCaptureEvents, trackImageCapture } from '../../../tracking/tracking.imageCapture';
import { CATEGORY_DISPLAY_ORDER } from '../../../utils/utils.image-capture';

@Component({
  tag: 'image-capture-container',
  styleUrl: 'image-capture-container.css',
})
export class ImageCaptureContainer {
  @Prop() imageGroupGuid = '';
  @Prop() imageUrls: string[] = [];
  @Prop() requiresAllPhotos = false;
  @Prop() shouldShowError = false;

  private guidelinesPopup: HTMLImageCaptureGuidelinesPopupElement;

  showPhotoGuidelines() {
    this.guidelinesPopup.open();

    trackImageCapture(ImageCaptureEvents.Guidelines, 'click');
  }

  renderNextInstruction() {
    if (!this.requiresAllPhotos) {
      return <span>No photos to add? Select Next</span>;
    }

    const photoRequiredInstructionClasses = {
      'flex xs:flex-col md:flex-row justify-center': true,
      'text-red-600': this.shouldShowError,
    };

    return (
      <div class={photoRequiredInstructionClasses}>
        <div>
          {this.shouldShowError && <svg-icon icon="image-capture-alert" height="1.1rem" class="inline-block pr-1 pt-1 relative top-1" />}
          Please upload all photos.&nbsp;Once completed, select Next
        </div>
      </div>
    );
  }

  render() {
    return (
      <div class="font-ico-body text-ico-body box-shadow">
        {/* Header */}
        <div class="flex justify-between xs:flex-col md:flex-row mb-2">
          <div class="flex items-baseline justify-start">
            <h1 class="ico-components-heading-large mr-2" data-testid="imageCaptureHeader">
              Add Photos
            </h1>
            {!this.requiresAllPhotos && (
              <span class="text-xs text-ico-heading" data-testid="imageCaptureHeaderOptional">
                (Optional)
              </span>
            )}
          </div>

          <div class="mt-1">
            <a onClick={() => this.showPhotoGuidelines()} class="cursor-pointer text-sm no-underline xs:font-bold md:font-medium" data-testid="imageCapturePhotoGuidelinesButton">
              See photo guidelines
            </a>
            <image-capture-guidelines-popup ref={(el) => (this.guidelinesPopup = el)} />
          </div>
        </div>

        {/* Description */}
        <div class="text-sm text-left mb-4" data-testid="imageCaptureDescription">
          Adding photos will give us a better sense of your vehicle's condition and may save you time at the dealership.
        </div>

        {/* Photoboxes */}
        <div class="grid w-fit image-capture-container__grid" data-testid="imageCapturePhotoboxContainer">
          {CATEGORY_DISPLAY_ORDER.map((category, index) => (
            <image-capture-photobox category={category} imageGroupGuid={this.imageGroupGuid} imageUrl={this.imageUrls[index]} />
          ))}
        </div>

        {/* Next Instruction */}
        <div class="mt-8 text-center text-sm font-bold" data-testid="imageCaptureNextInstruction">
          {this.renderNextInstruction()}
        </div>
      </div>
    );
  }
}
